import Link from 'next/link';
import { useRouter } from 'next/router';
import { useNotifications } from '@/contexts/NotificationContext';
import ThemeModeToggle from '@/components/layout/ThemeModeToggle';
import { useThemeMode } from '@/contexts/ThemeModeContext';

export default function Header({ toggleMenu }) {
    const router = useRouter();
    const { unreadCount } = useNotifications();
    const { resolvedMode } = useThemeMode();

    const shellClassName = resolvedMode === 'dark'
        ? 'border-b app-shell-glass backdrop-blur-md shadow-[inset_0_1px_0_rgba(255,255,255,0.1)]'
        : 'backdrop-blur-md inset-shadow-sm inset-shadow-teal-300';

    return (
        <header className="w-full h-14 sticky inset-0 z-50 bg-wave">
            <div className={`relative size-full px-4 py-2 flex items-center justify-between ${shellClassName}`}>
                <button
                    onClick={toggleMenu}
                    className="inline-flex size-10 items-center justify-center rounded-full transition-all hover:bg-white/10"
                    aria-label="Toggle navigation"
                >
                    <span className="material-icons text-white text-shadow-md text-shadow-black align-middle !text-3xl">
                        menu
                    </span>
                </button>
                <h1 className="pointer-events-none absolute left-1/2 -translate-x-1/2 text-2xl font-bold text-center text-white text-shadow-md text-shadow-black"
                >
                    ISABHEL
                </h1>
                <div className="flex items-center gap-2 sm:gap-3">
                    <ThemeModeToggle />
                    <Link
                        href="/notifications"
                        className={`relative inline-flex size-10 items-center justify-center rounded-full transition-all hover:bg-white/10 ${router.pathname === '/notifications' ? 'bg-white/15' : ''}`}
                        aria-label="Notifications"
                    >
                        <span className="material-icons text-white text-shadow-md text-shadow-black align-middle !text-2xl">
                            notifications
                        </span>
                        {unreadCount > 0 && (
                            <span className="absolute -top-1 -right-1 min-w-5 h-5 px-1 rounded-full bg-red-500 text-white text-[11px] font-bold leading-5 text-center shadow-md">
                                {unreadCount > 99 ? '99+' : unreadCount}
                            </span>
                        )}
                    </Link>

                    <Link
                        href="/profile"
                        className={`inline-flex size-10 items-center justify-center rounded-full transition-all hover:bg-white/10 ${router.pathname === '/profile' ? 'bg-white/15' : ''}`}
                        aria-label="Profile"
                    >
                        <span className="material-icons text-white text-shadow-md text-shadow-black align-middle !text-2xl">
                            person
                        </span>
                    </Link>
                </div>
            </div>
        </header>
    );
}
